module.exports = __webpack_public_path__ + "img/sponsor-1.f1d73ab1.jpg";